const ErrorPage = () => {
    return ( 
        <div>
            Error | 404
        </div>
     );
}
 
export default ErrorPage;